import { envConfig } from "@env/env-config";

/**
 * @description 用户注册 Rest配置
 * @deprecated
 */
export const KeyRestConfig = {
    getKey: {
        service: "keyRestService",
        funcName: "getKey",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/common/key",
            isAuth: true
        }
    }
}